import React from 'react';

import { useMySummaryView } from 'screens/home/hooks/useMySummaryView';

import { MODULE_KEYS1 } from 'constants/ProjectConstants';

import { SUMMARY_TYPE_MODULES } from '../constants';
import {
  CompetenciesMySummaryCard,
  EngagementMySummaryCard,
  FeedbackMySummaryCard,
  GoalsMySummaryCard,
  OneOnOneMySummaryCard,
  ReviewsMySummaryCard,
} from './Cards';
import { FeedbackProfileSummaryCard } from './Cards/Feedback/FeedbackProfileSummaryCard';
import { GoalsProfileSummaryCard } from './Cards/Goals/GoalsProfileSummaryCard';
import { InitiativesMySummaryAgGrid } from './Cards/Initiatives/InitiativesMySummaryAgGrid';
import { InitiativesProfileSummaryAgGrid } from './Cards/Initiatives/InitiativesProfileSummaryAgGrid';
import { CompetenciesProfileSummaryCard } from './Cards/LevelUp/CompetenciesProfileSummaryCard';
import { ReviewsProfileSummaryCard } from './Cards/Reviews/ReviewsProfileSummaryCard';

// TODO: Remove this "not so good logic"
// Doing it in a hacky way for now, will refactor it later
const GoalCardView = () => <GoalsMySummaryCard />;

// TODO: Remove this "not so good logic"
// Doing it in a hacky way for now, will refactor it later
const GoalCardViewForProfilePage = ({ employeeId }) => <GoalsProfileSummaryCard employeeId={employeeId} />;

export const SUMMARY_TYPE_CARDS = {
  [MODULE_KEYS1.GOAL]: GoalCardView,
  [MODULE_KEYS1.INITIATIVE]: InitiativesMySummaryAgGrid,
  [MODULE_KEYS1.REVIEW]: ReviewsMySummaryCard,
  [MODULE_KEYS1.ENGAGEMENT]: EngagementMySummaryCard,
  [MODULE_KEYS1.ONE_ON_ONE]: OneOnOneMySummaryCard,
  [MODULE_KEYS1.FEEDBACK]: FeedbackMySummaryCard,
  [MODULE_KEYS1.DEVELOP]: CompetenciesMySummaryCard,
};

export const PROFILE_PAGE_SUMMARY_TYPE_CARDS = {
  [MODULE_KEYS1.GOAL]: GoalCardViewForProfilePage,
  [MODULE_KEYS1.INITIATIVE]: InitiativesProfileSummaryAgGrid,
  [MODULE_KEYS1.REVIEW]: ReviewsProfileSummaryCard,
  // [MODULE_KEYS1.ENGAGEMENT]: EngagementMySummaryCard,
  // [MODULE_KEYS1.ONE_ON_ONE]: OneOnOneProfileSummaryCard,
  [MODULE_KEYS1.FEEDBACK]: FeedbackProfileSummaryCard,
  [MODULE_KEYS1.DEVELOP]: CompetenciesProfileSummaryCard,
};

const MySummaryContainer = () => {
  const { selectedMySummaryView } = useMySummaryView();

  // this is used to figure out which all modules are enabled and only those cards will be rendered;
  const APPLICABLE_SUMMARY_TYPES = SUMMARY_TYPE_MODULES[selectedMySummaryView]?.filter(({ moduleEnabled }) =>
    moduleEnabled()
  );

  if (!APPLICABLE_SUMMARY_TYPES?.length) {
    return <p>No my summary modules</p>;
  }

  return (
    <>
      {APPLICABLE_SUMMARY_TYPES?.map(({ module }, index) => {
        const CardComponent = SUMMARY_TYPE_CARDS[module];
        return <CardComponent key={`${module}-card-${index}`} />;
      })}
    </>
  );
};

export { MySummaryContainer };
